import { getElement, getElements, toggleClass } from '../helpers/functions';
export default () => {
  const $footerAccordions = getElements('.footer-accordion');
  $footerAccordions.forEach($accordion => {
    const $label = getElement('header', $accordion);
    const $frame = getElement('.frame', $accordion);
    if (!$label || !$frame) return;
    $label.addEventListener('click', () => {
      toggleClass($frame, '__open');
    });
  });
};